import type { FaqFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

export const googleItAutomationFaqs = (productPrice: number): Array<FaqFragment> => {
  return [
    {
      id: '1',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What is the refund policy?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'If you subscribed, you get a 7-day free trial during which you can cancel at no penalty. After that, we don’t give refunds, but you can cancel your subscription at any time. '
          )}<a href="https://learner.coursera.help/hc/en-us/articles/208280266-Refund-policies">${_t(
          'See our full refund policy.'
        )}</a></text>
        </co-content>
      `,
      },
    },
    {
      id: '2',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Can I just enroll in a single course?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Yes! To get started, click the course card that interests you and enroll. You can enroll and complete the course to earn a shareable certificate, or you can audit it to view the course materials for free. When you subscribe to a course that is part of a Certificate, you’re automatically subscribed to the full Certificate. Visit your learner dashboard to track your progress.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '3',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is this course really 100% online? Do I need to attend any classes in person?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'This course is completely online, so there’s no need to show up to a classroom in person. You can access your lectures, readings and assignments anytime and anywhere via the web or your mobile device.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '4',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Why is learning Python important?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'The world of IT is changing rapidly and knowing how to write code to solve problems and automate solutions is a crucial skill for anybody in IT.  The Google IT Automation with Python Professional Certificate will equip you with the latest job-ready skills to help you take your career to the next level.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '5',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('How long does it take to complete the Certificate?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'The Google IT Automation with Python Professional Certificate can be completed in about 6 months.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '6',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What background knowledge is necessary?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'This course requires no previous knowledge of programming. Familiarity with basic IT concepts, like operating systems, files and processes, networking and data management will be required in further courses. For learners with no IT background at all, we recommend taking the '
          )}><a href="https://www.coursera.org/specializations/google-it-support">Google IT Support Professional Certificate</a>.</text>
        </co-content>
      `,
      },
    },
    {
      id: '7',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Do I need to take the courses in a specific order?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'We highly recommend taking the courses in the order presented, as the content builds on information from earlier lessons.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '8',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What will I be able to do upon completing the Certificate?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'This new beginner-level, six-course certificate, developed by Google, is designed to provide IT professionals with in-demand skills -- including Python, Git, and IT automation -- that can help you advance your career. The Google IT Automation with Python Professional Certificate can help prepare you for a variety of roles in IT, like more advanced IT Support Specialist or Junior Systems Administrator positions.'
          )}</text>
          <text>${_t(
            'Upon completion of the program, you’ll get access to career resources that can help you prepare your resume and practice interviewing. '
          )}</text>
          <text>${_t(
            'The Google IT Automation with Python Professional Certificate is designed to teach you to: '
          )}</text>
          <list bulletType="bullets">
            <li>
              <text>Understand what Python is and why it’s relevant to IT (different career pathways)</text>
            </li>
            <li>
              <text>Write scripts in Python</text>
            </li>
            <li>
              <text>Understand the role of Automation in IT</text>
            </li>
            <li>
              <text>Manage files and processes with Python</text>
            </li>
            <li>
              <text>Setup your own developer environment in Python</text>
            </li>
            <li>
              <text>Understand why version control is a fundamental tool for coding and collaboration</text>
            </li>
            <li>
              <text>Employ Git for version control</text>
            </li>
            <li>
              <text>Use and interact with GitHub</text>
            </li>
            <li>
              <text>Implement debugging techniques</text>
            </li>
            <li>
              <text>Manage scarce resources in your IT systems</text>
            </li>
            <li>
              <text>Manage virtual machines and resources in the cloud</text>
            </li>
            <li>
              <text>Use Python libraries to automate different processes</text>
            </li>
            <li>
              <text>Analyze real-world IT problems and implement the appropriate strategies to solve those problems</text>
            </li>
          </list>
        </co-content>
      `,
      },
    },
    {
      id: '9',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What hardware or software do I need to complete the Certificate?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'The material requires a high-speed Internet connection, a modern web browser, and a desktop or laptop computer to complete the Qwiklabs/graded assessments. For the best experience, we strongly recommend that you have administrative privileges to modify OS permissions, that you can download your own editor, and that your machine is running a modern OS.'
          )}</text>
          <text>${_t(
            'To really get the most out of this program, we strongly recommend that you have Python installed on your machine. For some courses, you’ll need a computer where you can install Git or ask your administrator to install it for you.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '10',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is the Google IT Automation with Python Professional Certificate licensed?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Yes, the content in the Google IT Automation with Python Professional Certificate is licensed under a Creative Commons Attribution 4.0 International License.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '11',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('How much does this certificate cost?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Now INR #{productPrice}!', { productPrice })}</text>
          <text>${_t(
            'In India, Coursera charges INR #{productPrice}/month after the initial 7 day free trial period. The certificate can be completed in less than 6 months of part time study. Google does not generate any revenue from Google Career Certificates and has made need-based financial assistance available.',
            { productPrice }
          )}</text>
        </co-content>
      `,
      },
    },
  ];
};

export default googleItAutomationFaqs;
